import React from 'react'
import { Tooltip, Button, Icon  } from 'antd';

class EMDTableColumnName extends React.Component {

  constructor(props) {
    super(props);
    this.onAction = this.onAction.bind(this);
  }

  onAction (e, record) {
    e.preventDefault();
    const {onAction} = this.props;
    if (onAction) 
      onAction(record, "INFO", "50%");
  }

  render() {
    //console.log(this);
    const {value, row} = this.props;
    return (
      <span>{value}{'\u00A0'}
        {(row && !Array.isArray(row.annotations)) && (
          <Tooltip title="Информация по элементу">
            <Button shape="circle" size="small" onClick={(e)=>this.onAction(e, row)} ><Icon type="info" style={{ verticalAlign: "+0.125em"}}></Icon></Button>
          </Tooltip>
          )}
      </span>
    );
  }

}

export default EMDTableColumnName;